import { render, staticRenderFns } from "./entrustdet.vue?vue&type=template&id=71b7a75c&scoped=true&"
import script from "./entrustdet.vue?vue&type=script&lang=js&"
export * from "./entrustdet.vue?vue&type=script&lang=js&"
import style0 from "./entrustdet.vue?vue&type=style&index=0&id=71b7a75c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b7a75c",
  null
  
)

export default component.exports